import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'gea-hrt-empty-data-placeholder',
  imports: [TranslatePipe],
  template: `
    <div class="empty-data-placeholder">
      @if (useRawText()) {
        <p>{{ text() }}</p>
      } @else {
        <p>{{ 'EMPTY_DATA_PLACEHOLDER' | translate: { text: text() } }}</p>
      }
    </div>
  `,
  styles: `
    .empty-data-placeholder {
      text-align: center;
      p {
        font-size: 1.5rem;
      }
    }
  `,
})
export class EmptyDataPlaceholderComponent {
  readonly text = input.required<string>();
  /**
   * Set to `true` when `text` should be displayed exactly as provided,
   * without applying the translated `EMPTY_DATA_PLACEHOLDER` wrapper.
   */
  readonly useRawText = input(false);

  readonly translate = inject(TranslateService);
}
